// src/App.js
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import React, { useState } from "react";
import { auth } from "./firebase";

export function Signup() {
  const [loginOrSignUp, setLoginOrSignUp] = useState("login");
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [emailSignup, setEmailSignup] = useState("");
  const [passwordSignup, setPasswordSignup] = useState("");

  const handleEmailSignUp = async () => {
    try {
      await createUserWithEmailAndPassword(auth, emailSignup, passwordSignup);
      alert("Signed up successfully!");
    } catch (error) {
      console.error("Error signing up with email and password:", error.message);
      alert(`Sign up failed: ${error.message}`);
    }
  };

  const handleEmailSignIn = async () => {
    try {
      await signInWithEmailAndPassword(auth, emailSignup, passwordSignup);
      alert("Signed in successfully!");
    } catch (error) {
      console.error("Error signing in with email and password:", error.message);
      alert(`Sign in failed: ${error.message}`);
    }
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      alert("Signed in with Google successfully!");
    } catch (error) {
      console.error("Error signing in with Google:", error.message);
      alert(`Google sign in failed: ${error.message}`);
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
      }}
    >
      <h1>Schmart Schopping🙀</h1>
      <div style={{ display: "inline-block" }}>
        <span
          style={{
            padding: "1rem",
            fontSize: "1rem",
            fontWeight: "bold",
            backgroundColor: loginOrSignUp === "login" ? "lightblue" : "azure",
            border: "1px solid black",
            borderRight: 0,
            borderTopLeftRadius: 50,
            borderBottomLeftRadius: 50,
          }}
          onClick={() => setLoginOrSignUp("login")}
        >
          Einloggen
        </span>
        <span
          style={{
            padding: "1rem",
            fontSize: "1rem",
            fontWeight: "bold",
            backgroundColor: loginOrSignUp === "signup" ? "lightblue" : "azure",
            border: "1px solid black",
            borderRight: "1px solid black",
            borderTopRightRadius: 50,
            borderBottomRightRadius: 50,
          }}
          onClick={() => setLoginOrSignUp("signup")}
        >
          Registrieren
        </span>
      </div>
      <div>
        {loginOrSignUp === "login" ? (
          <>
            <h2>Login</h2>
            <input
              type="email"
              placeholder="Email"
              value={emailLogin}
              onChange={(e) => setEmailLogin(e.target.value)}
              style={{ margin: "5px", padding: "8px" }}
            />
            <input
              type="password"
              placeholder="Password"
              value={passwordLogin}
              onChange={(e) => setPasswordLogin(e.target.value)}
              style={{ margin: "5px", padding: "8px" }}
            />
            <button
              onClick={handleEmailSignIn}
              style={{ margin: "5px", padding: "10px" }}
            >
              Einloggen mit E-Mail
            </button>
          </>
        ) : (
          <>
            <h2>Registrierung</h2>
            <p>
              Nach deiner Anmeldung sag mir kurz Bescheid, mit welchem Account
              du dich registriert hast, dann schalte ich dich frei
            </p>
            <input
              type="email"
              placeholder="Email"
              value={emailSignup}
              onChange={(e) => setEmailSignup(e.target.value)}
              style={{ margin: "5px", padding: "8px" }}
            />
            <input
              type="password"
              placeholder="Password"
              value={passwordSignup}
              onChange={(e) => setPasswordSignup(e.target.value)}
              style={{ margin: "5px", padding: "8px" }}
            />
            <button
              onClick={handleEmailSignUp}
              style={{ margin: "5px", padding: "10px" }}
            >
              Registrieren mit E-Mail
            </button>
          </>
        )}
      </div>
      <div>
        <button
          onClick={handleGoogleSignIn}
          style={{
            padding: "10px",
            backgroundColor: "#4285F4",
            color: "white",
            border: "none",
          }}
        >
          Registrieren/Einloggen mit Google
        </button>
      </div>
    </div>
  );
}
